export const openExternalUrl = (url: string) => {
  window.open(url, '_blank');
};
